up.compiler('[data-skip-link]', (element) => {
  element.addEventListener('click', (event) => {
    event.preventDefault()
    document.querySelector<HTMLElement>('#main')!.focus({
      preventScroll: true,
    })
  })
})
